import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { throwIfHasNoPermission } from "@/utils/permissions";

import NewsForm from "@/modules/news/admin/components/NewsForm";
import { fetchNewsQueryOptions } from "@/modules/news/admin/services";

export const Route = createFileRoute("/admin/_panel/_news/news/$id")({
  component: Component,
  parseParams: (params) => ({
    id: z.number().int().parse(Number(params.id)),
  }),
  beforeLoad: ({ context }) => {
    throwIfHasNoPermission(context.user, "news.news.update");

    return {
      crumb: [
        {
          label: context.t("Edit", { ns: "core.shared" }),
        },
      ],
    };
  },
  loader: (opts) =>
    opts.context.queryClient.ensureQueryData(
      fetchNewsQueryOptions(opts.params.id),
    ),
  stringifyParams: ({ id }) => ({ id: `${id}` }),
});

function Component() {
  const { id } = Route.useParams();

  return <NewsForm id={id} />;
}
